import m from "../../geodata/es2015/serbiaNoKosovoHigh";
window.am4geodata_serbiaNoKosovoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/serbiaNoKosovoHigh.js
// module id = null
// module chunks = 